<template>
    <div class="relative">
        <button class="flex items-center text-xs" @click.prevent="toggle">
            <img :src="user.avatar_url" :alt="user.name" class=" flex-shrink-0 w-8 rounded-md m-2">
            <font-awesome-icon :icon="['fas', 'chevron-down']"></font-awesome-icon>
        </button>

        <button v-if="isOpen" @click.prevent="toggle" tabindex="-1" class="fixed inset-0 h-full w-full cursor-default"></button>
        <div class="w-48 block absolute right-0 top-full border border-gray-dark bg-white text-black tracking-wider rounded-md shadow-xl z-20" :class="isOpen ? '' : 'hidden'">
            <a href="/reviewer" class="block px-4 py-2 my-1 hover:bg-gray-dark">
                <font-awesome-icon :icon="['fas', 'map-signs']"></font-awesome-icon>
                <span class="ml-2">Daily Digest</span>
            </a>
            <a href="/settings" class="block px-4 py-2 my-1 hover:bg-gray-dark">
                <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                <span class="ml-2">Settings</span>
            </a>
            <a href="/magazines" class="block px-4 py-2 my-1 hover:bg-gray-dark">
                <font-awesome-icon :icon="['fas', 'newspaper']"></font-awesome-icon>
                <span class="ml-2">Magazines</span>
            </a>
            <span class="border-t border-gray-dark block"></span>
            <a href="/ambassador" class="block px-4 py-2 my-1 hover:bg-gray-dark">
                <font-awesome-icon :icon="['fas', 'user-astronaut']"></font-awesome-icon>
                <span class="ml-2">Ambassador</span>
            </a>
            <a href="/teams" class="block px-4 py-2 my-1 hover:bg-gray-dark">
                <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
                <span class="ml-2">Teams</span>
            </a>
            <a href="/account" class="block px-4 py-2 my-1 hover:bg-gray-dark">
                <font-awesome-icon :icon="['fas', 'user']"></font-awesome-icon>
                <span class="ml-2">Account</span>
            </a>
            <div v-if="user.has_billing">
                <a href="/billing" class="block px-4 py-2 my-1 hover:bg-gray-dark">
                    <font-awesome-icon :icon="['fas', 'money-check-alt']"></font-awesome-icon>
                    <span class="ml-2">Billing</span>
                </a>
            </div>
            <span class="border-t border-gray-dark block"></span>
            <a href="/auth/logout" class="block px-4 py-2 my-1 hover:bg-destructive hover:text-white text-destructive">
                <font-awesome-icon :icon="['fas', 'sign-out-alt']"></font-awesome-icon>
                <span class="ml-2">Logout</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user  : window.User,
            isOpen: false,
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    }
}
</script>
